export class UpdateUsuarioRequest {
    public userName!: string;
    public nombre!: string;
    public apellido!: string;
    public telefono!: string;
    public codigoPostal!: string;
    public direccion!: string;
}
